module.exports = __webpack_public_path__ + "img/invite_coupon_use.b3804a97.png";